import React from 'react';
import { Route, Routes } from 'react-router-dom';
import {THANK_YOU_URL} from "../Util/routes";
import ThankYouPage from "../Pages/ThankYou";
import PagesRoutes from "./pagesRoutes";

const MyRoute = () => (
    <Routes>
        <Route exact path="/*" element={<PagesRoutes/>}/>
        <Route exact path={`${THANK_YOU_URL}`} element={<ThankYouPage/>} />
    </Routes>
);

export default MyRoute;
